import React from 'react';
import AboutPage from '../components/landing/AboutPage';

const About = () => {
  return <AboutPage />;
};

export default About;
